'use es6';

import I18n from 'I18n';
import { Map as ImmutableMap, Range } from 'immutable';
import { registerQuery } from 'data-fetching-client';
import { fetchRetentionReport, formatDuration } from '../utils/unifiedEvents';
import { RETENTION_REPORT_NAME, VIDEO_RETENTION_QUERY_FIELD_NAME } from '../constants';
export const VIDEO_RETENTION_QUERY = registerQuery({
  args: ['crmPageObjectCoordinate', 'contentId', 'startDateInt', 'endDateInt', 'videoObjectCoordinate'],
  fetcher: fetchRetentionReport,
  fieldName: VIDEO_RETENTION_QUERY_FIELD_NAME
});
export const getRetentionVisualization = (reportData, {
  duration
} = {}) => {
  const breakdowns = reportData.map(bucket => bucket.get('breakdown'));
  const minBreakdownSecond = breakdowns.first();
  const maxBreakdownSecond = duration ? Math.ceil(duration / 1000) : breakdowns.last();
  const range = Range(minBreakdownSecond, maxBreakdownSecond).toList();
  const data = range.map(breakdownSecond => {
    const bucket = reportData.find(b => b.get('breakdown') === breakdownSecond);
    return ImmutableMap({
      breakdown: String(breakdownSecond).padStart(4, '0'),
      secondsLabel: formatDuration(breakdownSecond),
      viewsPerSecond: bucket ? bucket.getIn(['counterValues', RETENTION_REPORT_NAME, 'value']) : 0
    });
  });
  const dataSeriesProperties = {
    secondsLabel: {
      label: I18n.text('videoReports.videoRetentionChart.duration')
    },
    viewsPerSecond: {
      label: I18n.text('videoReports.videoRetentionChart.viewsPerSecond')
    }
  };
  return {
    data: {
      primary: {
        data,
        properties: dataSeriesProperties
      }
    },
    layers: [{
      dataset: 'primary',
      mark: {
        type: 'line'
      },
      x: {
        field: 'secondsLabel',
        type: 'category'
      },
      y: {
        field: 'viewsPerSecond',
        type: 'linear'
      }
    }],
    type: 'XY'
  };
};